<template>
  <template v-if="hasConfig">
    <div v-if="isLoggedIn">
      <Inicio />
      <Vue3ProgressBar style="height: 6px!important;" />
      <Menu/>
      <main id="main" class="main">
        <div class="section dashboard">
          <router-view />
        </div>
      </main>
      <MenuLateral/>
    </div>
    <Login v-else />
  </template>
  <div v-else class="text-center text-sm labes7" style="margin-top:300px; font-size:25px;">
    <p>Cargando pagina...</p>
  </div>
</template>
<script>
import Menu from "./shared/Menu.vue";
import Login from "./modules/auth/views/LoginView.vue";
import Inicio from "./shared/Inicio.vue";
import VTypical from 'vue-typical';
import MenuLateral from "./shared/MenuLateral.vue";
export default {
  name: "app",
  mounted() {
    this.initialize();
  },
  components: {
    Menu,
    Login,
    Inicio,
    VTypical,
    MenuLateral,
  },
  data() {
    return {
      hasConfig: false,
      isLoggedIn: false
    };
  },
  methods: {
    initialize() {
      let self = this;
      self.hasConfig = true;
      __isLogedIn();
      function __isLogedIn() {
        if (localStorage.getItem("access_token") != null) {
          self.isLoggedIn = true;
        }
      }
    },
  }
};
</script>
<style>
@import './assets/styles/style.css';
@import './assets/styles/mainstyles.css';
</style>

